import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ICoordinate {
    x: number;
    y: number;
}
const layoutStateSlice = createSlice({
    name: 'layoutstate',
    initialState: {
        floatingLocation: { x: 0, y: 0 },
        overlay: true,
        leftPanelLeads: "PROFILE"
    },
    reducers: {
        setFloatingCoordinate: (state, action: PayloadAction<ICoordinate>) => {
            state.floatingLocation = action.payload
        },
        setOverlay: (state, action: PayloadAction<boolean>) => {
            state.overlay = action.payload
        },
        setLeftPanelLeads: (state, action: PayloadAction<"PROFILE" | "CALL_SCHEDULE" | "CHAT_AGENT">) => {
            state.leftPanelLeads = action.payload
        }
    },
})

export const {
    setFloatingCoordinate,
    setOverlay,
    setLeftPanelLeads
} = layoutStateSlice.actions
export default layoutStateSlice.reducer


